import {useContext, useEffect, useState} from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import {IAM_SERVER_AUTH_TOKEN_POLICY, IAM_SERVER_SERVICE} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import eye from "../../../resources/images/icon-font-eye.svg";
import eyeClose from "../../../resources/images/icon-font-eye-crossed.svg";
import { InnocodeButton, useInnocodeLoadingOverlay } from "@intsoft/innocode-core";
import Switch from "@mui/material/Switch";



/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const ServiceDetailModal = ({id, update}) => {

    const {closeModal} = useContext(ModalContext);
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay(); 
    const [showSecret, setShowSecret] = useState(false);

    const [formData, setFormData] = useState({
        serviceId: '',
        serviceName: '',
        serviceDomain: '',
        apiKey:'',
        autoJoinEnabled: true
    });

    const [formPolicyData, setFormPolicyData] = useState({
        clientId:'',
        refreshTokenTime: '',
        accessTokenTime: '',
        redirectUri: '',
        clientSecret:''
    });

    useEffect(() => {
        showLoading();
        // id로 서비스 정보 조회
        const url = IAM_SERVER_SERVICE + "/get/" + id;
        axios.get(url)
            .then((res) => {

                setFormData({
                    serviceId: res.data.data.serviceId,
                    serviceName: res.data.data.serviceName,
                    serviceDomain: res.data.data.serviceDomain,
                    apiKey:res.data.data.apiKey,
                    autoJoinEnabled: res.data.data.autoJoinEnabled !== false
                });


                //serviceId로 서비스토큰정책 조회회
                const authTokenPolicyUrl = IAM_SERVER_AUTH_TOKEN_POLICY + "/get/" + id;
                axios.get(authTokenPolicyUrl)
                    .then((policyRes) => {

                        setFormPolicyData({
                            clientId:policyRes.data.data.clientId,
                            refreshTokenTime: policyRes.data.data.refreshTokenTime,
                            accessTokenTime: policyRes.data.data.accessTokenTime,
                            redirectUri: policyRes.data.data.redirectUri,
                            clientSecret: policyRes.data.data.clientSecret
                        });
                    })
                    .catch((e) => {
                        showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
                    })
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                hideLoading();
            })         
    }, []);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
        setFormPolicyData((prevState) => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    }

    const handleAutoJoinChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            autoJoinEnabled: e.target.checked
        }));
    }


    // 사용자 상세정보 수정 요청 API
    const handleModify = () => {
        const url = IAM_SERVER_SERVICE + "/update";
        const authTokenPolicyUrl = IAM_SERVER_AUTH_TOKEN_POLICY + "/update";
        const params = Object.assign({}, formData);
        const policyParams = Object.assign({}, formPolicyData);

        axios.post(url, params)
            .then((res) => {
                axios.post(authTokenPolicyUrl, policyParams)
                    .then((res) => {
                        showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                        update();
                    })
                    .catch((e) => {
                        showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                    })
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }

    
    const handleDelete = () => {
        const url = IAM_SERVER_SERVICE + "/delete/"+formData.serviceId;
        const authTokenPolicyUrl = IAM_SERVER_AUTH_TOKEN_POLICY + "/delete/"+formData.serviceId;

        axios.post(url)
            .then((res) => {
                axios.post(authTokenPolicyUrl)
                    .then((res) => {
                        showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                        update();
                    })
                    .catch((e) => {
                        showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                    })
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }

    return (
        <div style={{overflow: "auto"}}>
            <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>서비스 아이디</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"serviceId"}
                                value={formData.serviceId}
                                readOnly={true}
                                onChange={handleChange}/>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>서비스 명</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"serviceName"}
                                value={formData.serviceName}
                                onChange={handleChange}/>
                        </li>
                        <li className={styles.layer__list}>
                            <p lang={"ko"} className={styles.layer__listTit}>서비스 도메인</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"serviceDomain"}
                                value={formData.serviceDomain}
                                onChange={handleChange}/>
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>자동가입</p>
                            <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                <Switch
                                    checked={formData.autoJoinEnabled}
                                    onChange={handleAutoJoinChange}
                                    color="primary"
                                />
                                <span style={{fontWeight: 600, color: formData.autoJoinEnabled ? '#2458e6' : '#777'}}>
                                    {formData.autoJoinEnabled ? '허용' : '미허용'}
                                </span>
                            </div>
                        </li>
                    </ul>

                    <div className={styles.layer__sensorBox}>
                        <p className={styles.layer__sensorTit}>정책설정</p>
                        <ul className={styles.layer__listWrap}>
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>토큰시간(s)</p>
                                <input className={styles.layer__listInput}
                                    type={"number"}
                                    name={"accessTokenTime"}
                                    value={formPolicyData.accessTokenTime}
                                    onChange={handleChange}/>
                            </li>
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>리플래시 토큰시간(s)</p>
                                <input className={styles.layer__listInput}
                                    type={"number"}
                                    name={"refreshTokenTime"}
                                    value={formPolicyData.refreshTokenTime}
                                    onChange={handleChange}/>
                            </li>
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>Redirect URL</p>
                                <input className={styles.layer__listInput}
                                    type={"text"}
                                    name={"redirectUri"}
                                    value={formPolicyData.redirectUri}
                                    onChange={handleChange}/>
                            </li>
                            <li className={styles.layer__list}>
                                <p className={styles.layer__listTit}>서비스 Secret</p>
                                <input className={styles.layer__listInput}
                                    type={showSecret ? "text" : "password"}
                                    name={"clientSecret"}
                                    value={formPolicyData.clientSecret}
                                    readOnly={true}
                                    onChange={handleChange}/>
                                <button
                                    type="button"
                                    onClick={() => setShowSecret(!showSecret)}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        marginLeft: "0px",
                                        cursor: "pointer",
                                        padding: 0
                                    }}
                                    tabIndex={-1}
                                >
                                    <img
                                        src={showSecret ? eye : eyeClose}
                                        alt={showSecret ? "숨기기" : "보기"}
                                        style={{ width: 24, height: 24 }}
                                    />
                                </button>    
                            </li>
                        </ul>
                    </div>

                    <div className={styles.layer__sensorBtnBox}>
                        <InnocodeButton onClick={handleDelete} size="md" backgroundColor="var(--status-negative, #f83a3a)" fullWidth={true}>삭제</InnocodeButton>
                        <InnocodeButton onClick={handleModify} size="md" fullWidth={true}>수정</InnocodeButton>
                        {/* <button className={styles.layer__cancleBtn} onClick={handleDelete}>삭제</button>
                        <button className={styles.layer__modifyBtn} onClick={handleModify}>수정</button>                         */}
                    </div>
                </div>
        </div>
    );
}
